// eslint-disable-next-line import/no-unresolved
import locationSVG from '../../static/icons/location.svg';

export default class CompactFilterObject {
  constructor(
    public title: string,
    public type: FilterTypes,
    public func: (filterObject: CompactFilterObject, item: never) => boolean,
    public icon: typeof locationSVG,
    public active: string[] = [],
    public all: CompactFilterValue[] = type === 'switch'
      ? [{ label: 'boolean', value: 'false' }]
      : [],
    public toQuery?: (
      active: string[],
      context?: Record<string, string>,
    ) => Record<string, any>,
  ) {}
}

export type FilterTypes = 'select' | 'switch';

export interface CompactFilterValue {
  label: string;
  value: string;
}

export interface CompactFilterDialogProps {
  values: CompactFilterValue[];
  active: string[];
  onChangeValue: (filterObject: CompactFilterValue) => void;
}
